import { ReactNode } from 'react'
import styled from 'styled-components'

type BaseSvgProps = {
  children: ReactNode
  viewBox: string
  style?: object
  className?: string
  title: string
  onClick?: () => void
}

const StyledSvg = styled.svg`
  height: 1rem;
  width: 1rem;
`

// TODO Remove the ...rest once all icons are not clickable
const BaseSvg = ({ children, className, style, viewBox, title = 'icon', ...rest }: BaseSvgProps) => {
  const id = `${title.replace(/ /, '')}-icon-title`
  return (
    <StyledSvg
      viewBox={viewBox}
      version="1.1"
      className={className}
      style={style}
      role="img"
      {...rest}
      aria-labelledby={id}
    >
      <title id={id}>{title}</title>
      {children}
    </StyledSvg>
  )
}

BaseSvg.displayName = 'BaseSvg'

export default BaseSvg
